import "../../utils/messages";
import { LOGIN_FAILED, LOGOUT_FAILED } from "../../utils/messages";
import qs from 'querystring';
import router from "..";


export function assignAuthRequests(api) {
    //-------------------------LOGIN--------------------------------------
    api.login = async function (username, password) {
        var config = {
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };

        var clientMessage = null;
        var response = await this.post('/oauth/login', qs.stringify({ "username": username, "password": password }), config)
            .then(res => {
                if (res.status == 400) {
                    console.writeError(res.data.message);
                    this.createToastFunction(this.translateFunction(LOGIN_FAILED), "alert");
                    if (res.data.message.contains("License expired")) {
                        return {
                            message: "LicenseExpired"
                        }
                    }
                    return null;
                }
                return res.data;
            }).catch(e => {
                clientMessage = this.checkError(e, LOGIN_FAILED, null, false);
                if (e?.data?.error == "license_expired") {
                    var authObj = e.data;
                    authObj.message = "LicenseExpired";
                    return authObj;
                }
                this.emitFunction("sendClientMessage", clientMessage, 'login');
                return null;
            });


        return response;
    }
    //TODO: Andrea la deve implementare sul server. Passare il token
    api.logout = async function (config) {
        var response = await api.post('/auth/logout', config)
            .then(() => {
                return true
            })
            .catch(e => {
                this.checkError(e, LOGOUT_FAILED);
                return false;
            });
        return response;
    }

    api.loginTFA = async function (TFACode, options = {}) {
        var config = {
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json',
            }
        }

        var body = {
            "totp_code": TFACode
        };

        const endpoint = options?.otpLogin === true
            ? '/oauth/mfa/otp/login'
            : '/oauth/mfa/login';

        var response = await api.post(endpoint, body, config)
            .then(res => {
                if (res.status == 400) {
                    console.writeError(res.data.message);
                    this.createToastFunction(this.translateFunction(LOGIN_FAILED), "alert");
                    return null;
                }
                return res.data;
            }).catch(e => {
                this.checkError(e, LOGIN_FAILED);
                return null;
            });

        return response;
    }

    api.loginTFARecovery = async function (TFACodeRecovery) {
        var config = {
            withCredentials: true,
            credentials: 'include',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            }
        };

        var body = qs.stringify({ "RecoveryCode": TFACodeRecovery });

        var response = await api.post('/auth/recovery', body, config)
            .then(res => {
                if (res.status == 400) {
                    console.writeError(res.data.message);
                    this.createToastFunction(this.translateFunction(LOGIN_FAILED), "alert");
                    return null;
                }
                return res.data;
            }).catch(e => {
                this.checkError(e, LOGIN_FAILED);
                return null;
            });

        return response;
    }
    // [TG - 19/03/2026 ] login con il token che proviene o da remote.iperius.com o da client desktop
    api.loginWithToken = async function (token) {

        const config = {
            ...this.buildConfig(),
            withCredentials: true,
            credentials: 'include'
        };

        var response = await api.get('/oauth/otp?otp=' + token, config)
            .then(res => {
                if (res.status == 400) {
                    console.writeError(res.data.message);
                    this.createToastFunction(this.translateFunction(LOGIN_FAILED), "alert");
                    return null;
                }
                return res.data;
            }).catch(e => {
                //10/09/2026 - Veronica : Se IperiusOne viene aperto tramite il bottone su Iperius Remote e 
                // l'utente non risulta precedentemente loggato su One, lo riporto alla pagina li login
                if (e.status && e.status == 404) {
                    sessionStorage.clear();
                    localStorage.removeItem("AUTH")
                    window.location.href = "/";
                    router.replace('/login');
                    return;
                }
                this.checkError(e, LOGIN_FAILED);

                return null;
            });

        return response;
    }
}